<template>
    <div ref="scroll_container" class="app-container">
        <el-form class="filter-container" size="small" inline>
            <el-form-item label="查询">
              <el-input v-model="queryParams.searchKey" clearable placeholder="手机号/入住人/标题" style="width: 300px;" @keyup.enter.native="handleFilter" />
            </el-form-item>
            <el-form-item label="订单项ID">
              <el-input v-model="queryParams.id" clearable placeholder="" style="width: 300px;" @keyup.enter.native="handleFilter" />
            </el-form-item>
            <el-form-item label="状态">
              <el-radio-group v-model="queryParams.status" size="small">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button v-for="item in statusList" :key="item" :label="item">{{ statusMap[item].text }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-button class="filter-item" size="small" type="success" icon="el-icon-search" style="margin-left: 10px;" @click="handleFilter">搜索</el-button>
        </el-form>
        <el-table ref="accountTable" v-loading="loading" :data="accountList" size="mini" border highlight-current-row>
            <el-table-column prop="id" label="ID" width="60" />
            <el-table-column prop="orderType" label="订单类型" width="80" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.orderType===1">酒店</div>
                    <div v-if="scope.row.orderType===2||scope.row.orderType===3">套餐</div>
                </template>
            </el-table-column>
            <el-table-column prop="orderId" label="订单id" width="100" align="center">
                <template slot-scope="scope">
                    <div style="color:#1890ff;cursor:pointer;" @click="goOrderList(scope.row)">{{ scope.row.orderId }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="orderTitle" label="名称" min-width="200">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.orderTitle" placement="top">
                    <div class="text-ellipsis">{{ scope.row.orderTitle }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="标题" min-width="200" />
            <el-table-column prop="type" label="类型" width="140">
              <template slot-scope="scope">
                <el-tag type="info">{{ typeMap[scope.row.type] }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="金额" width="120" />
            <el-table-column prop="status" label="状态" width="120">
              <template slot-scope="scope">
                <el-tag :type="statusMap[scope.row.status].style">{{ statusMap[scope.row.status].text }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="120" />
            <el-table-column prop="gmtCreate" label="创建时间" width="180" />
            <el-table-column label="操作" width="130" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="handleCancel(scope.row)">取消</el-button>
              </template>
            </el-table-column>
        </el-table>
        <base-pagination v-show="total>0" :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.size" @pagination="getList" />
    </div>
</template>
<script>
import { orderItemPage, orderItemClose } from '@/api/order'
import { orderItemTypeMap } from '@/utils/enums/orderItemEnums'
export default {
    name: 'HotelOrderItem',
    data() {
        return {
            accountList: [],
            total: 0,
            loading: false,
            queryParams: {
                page: 1,
                size: 20,
                searchKey: '',
                status: '',
                id: ''
            },
            statusList: ['DOING', 'PAY_SUCCESS', 'CANCEL'],
            statusMap: {
                'DOING': {
                  text: '支付中',
                  style: 'warning'
                },
                'PAY_SUCCESS': {
                  text: '已支付',
                  style: 'success'
                },
                'CANCEL': {
                  text: '已取消',
                  style: 'info'
                }
            },
            typeMap: orderItemTypeMap
        }
    },
    created() {
      this.getRouterParams()
      this.getList()
    },
    methods: {
        getRouterParams() {
            console.log('this.$route', this.$route)
            if (this.$route.query.id) {
                this.queryParams.id = this.$route.query.id
            }
        },
        async getList () {
            this.loading = true
            const params = { ...this.queryParams }
            params.searchKey = params.searchKey.trim()
          params.id = params.id.trim()
            const res = await orderItemPage(params)
            this.loading = false
            if (Number(res.status) === 2000) {
                this.accountList = res.data.records
                this.total = Number(res.data.total)
                this.accountList.forEach(item => {
                  item.orderTitle = item.extra.order.title
                  item.orderType = item.extra.order.type
                })
            }
        },
        handleFilter () {
            this.queryParams.page = 1
            this.getList()
        },
        goOrderList(row) {
          if (row.orderType === 1) {
            this.$router.push({ path: '/order/hotel/' + row.orderId })
          }
          if (row.orderType === 2 || row.orderType === 3) {
            this.$router.push({ path: '/order/pack/' + row.orderId })
          }
        },
        handleCancel(row) {
          this.$confirm('确认取消该订单项吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              const res = await orderItemClose({ id: row.id })
              if (Number(res.status) === 2000) {
                this.$message({
                  type: 'success',
                  message: '取消成功!'
                })
                this.getList()
              }
            }).catch(() => {
          })
        }
    }
}
</script>
